/* global fetch */

// TODO Write tests or manually test all callers

const request = async (rp) => {
  let headers = {}
  if (rp.data) {
    headers['Content-Type'] = 'application/json'
  }
  if (rp.headers) {
    headers = Object.assign(headers, rp.headers)
  }

  let body
  if (rp.data) {
    body = typeof rp.data === 'object' ? JSON.stringify(rp.data) : rp.data
  }

  return fetch(
    rp.url,
    {
      method: rp.method, // *GET, POST, PUT, DELETE, etc.
      // mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers,
      // redirect: 'follow', // manual, *follow, error
      // referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body
    })
}

export default {
  request,
  post: async (url, bodyJson) => {
    return request({
      url,
      method: 'POST',
      data: bodyJson
    })
  }
}
